import { Alert } from 'antd';

import { FareType } from '../../../typesFinancial';
import { getRmMovement } from '../../../utils/lists';

type ReasonBlock =
  | { kind: 'text'; value: string }
  | { kind: 'list'; items: string[] };

const LIST_ITEM_PREFIX = '- ';

function toReasonBlocks(reason: string): ReasonBlock[] {
  return reason
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
    .reduce<ReasonBlock[]>((blocks, line) => {
      if (!line.startsWith(LIST_ITEM_PREFIX)) {
        return [...blocks, { kind: 'text', value: line }];
      }

      const item = line.slice(LIST_ITEM_PREFIX.length);
      const last = blocks[blocks.length - 1];

      if (last?.kind === 'list') {
        return [
          ...blocks.slice(0, -1),
          { kind: 'list', items: [...last.items, item] },
        ];
      }

      return [...blocks, { kind: 'list', items: [item] }];
    }, []);
}

export function RejectionReason(props: { reason: string }) {
  const { reason } = props;

  return (
    <>
      {toReasonBlocks(reason).map((block) =>
        block.kind === 'text' ? (
          <div key={`text-${block.value}`}>{block.value}</div>
        ) : (
          <ul
            key={`list-${block.items[0]}`}
            style={{ margin: '4px 0', paddingInlineStart: 20 }}
          >
            {block.items.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        )
      )}
    </>
  );
}

export function FareTransmissionAlert(props: { fare: FareType }) {
  const { fare } = props;

  if (fare.status !== 'SEND_ERROR') return null;

  const acceptedRecordKeys = fare.rm_accepted_record_keys || [];
  // Em SEND_ERROR, `is_substitution` é o da tentativa que falhou, e é nesse
  // movimento que o faturista reenvia ou estorna o que ficou gravado.
  const movement = getRmMovement(fare.is_substitution);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        marginBottom: 16,
      }}
    >
      {fare.rm_error_reason && (
        <Alert
          type="error"
          showIcon
          message={`Erro no envio ao TOTVS RM, movimento ${
            movement.code
          } (${movement.name.toLowerCase()})`}
          description={<RejectionReason reason={fare.rm_error_reason} />}
        />
      )}
      {acceptedRecordKeys.length > 0 && (
        <Alert
          type="warning"
          showIcon
          message={`Gravado no movimento ${
            movement.code
          } do RM: ${acceptedRecordKeys.join(', ')}`}
          description={`Esta tarifa não pode mais ser enviada: um envio anterior parou no meio e deixou movimentação gravada no TOTVS RM. Estorne essas movimentações no movimento ${movement.code}, dentro do RM, e cobre os itens em uma tarifa nova.`}
        />
      )}
    </div>
  );
}
